// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1EventsPayloadSchema = z.object({
  user_id: z.optional(z.number().int().describe("User who performed the work (defaults to authenticated user)")),
  project_id: z.number().int().describe("Project to log time against (required)"),
  hours: z.optional(z.number().int().min(0).describe("Hours worked (0-23)")),
  minutes: z.optional(z.number().int().min(0).max(59).describe("Minutes worked (0-59)")),
  seconds: z.optional(z.number().int().min(0).max(59).describe("Seconds worked (0-59)")),
  from: z.coerce.string().describe("Start time in HH:MM format (e.g., \"09:00\")").nullish(),
  to: z.coerce.string().describe("End time in HH:MM format (e.g., \"17:00\")").nullish(),
  day: z.coerce.string().describe("Date of work in YYYY-MM-DD format (required)"),
  note: z.coerce.string().describe("Description of work performed").nullish(),
  sequence: z.optional(z.number().int().describe("Order of entry within the day")),
  estimated_hours: z.optional(z.number().int().min(0).describe("Planned hours for this task")),
  estimated_minutes: z.optional(z.number().int().min(0).max(59).describe("Planned minutes for this task")),
  billed: z.optional(z.boolean().describe("Mark as already billed")),
  locked: z.optional(z.boolean().describe("Lock entry to prevent editing")),
  billable: z.optional(z.boolean().describe("Override project billability setting")),
  hour_rate: z.optional(z.number().describe("Hourly billing rate for this entry")),
  internal_hour_rate: z.optional(z.number().describe("Internal cost rate for this entry")),
  timer_state: z.optional(z.number().int().describe("Timer state (0=stopped, 1=running)")),
  suggestion_id: z.number().int().describe("AI suggestion ID if accepting a suggestion").nullish(),
  autosheet_proposal_id: z.coerce.string().describe("AutoSheet proposal UUID this hour was created from (autosheet revert keys on this field)").nullish(),
  external_id: z.coerce.string().describe("External reference ID this entry").nullish(),
  forecast_id: z.number().int().describe("Task that this work fulfills").nullish(),
  forecast_completed_at: z.coerce.string().describe("Timestamp when task was completed").nullish(),
  state_id: z.number().int().describe("Workflow state").nullish(),
  project_join_mode: z.optional(z.enum(["add", "log_once"]).describe("With ALL_PROJECTS_LOGGING, controls membership when logging to a non-member project: \"add\" keeps the user as a member (default), \"log_once\" logs the entry then removes the membership")),
  label_ids: z.optional(z.array(z.number().int()).describe("Tags to apply")),
  user_ids: z.optional(z.array(z.number().int()).describe("Additional team members involved")),
  entry_ids: z.optional(z.array(z.number().int()).describe("Memory entries to include")),
  timestamps: z.optional(z.array(z.object({
    id: z.optional(z.number().int().describe("Timestamp ID (for updates)")),
    from: z.coerce.string().describe("Start time (HH:MM format)").nullish(),
    to: z.coerce.string().describe("End time (HH:MM format)").nullish(),
    entry_ids: z.optional(z.array(z.number().int()).describe("Memory entries for this segment")),
  })).describe("Time segments (for split entries across day)")),
  external_links: z.optional(z.array(z.object({
    provider_id: z.coerce.string().describe("Integration provider ID"),
    provider_type: z.coerce.string().describe("Type of external system (e.g., \"jira\", \"github\")"),
    external_id: z.coerce.string().describe("ID in external system (e.g., ticket number)"),
    data: z.optional(z.object({}).describe("Additional metadata from external system")),
    uri: z.optional(z.coerce.string().describe("Direct link to external resource")),
  })).describe("Links to related tickets, PRs, or documents")),
  linked_work_item_ids: z.optional(z.array(z.number().int()).describe("Linked work items to attach (replaces all native linked work; pass empty array to clear)")),
});
